/**
 * Admin-specific error shapes.
 *
 * The admin controllers wrap every answer in `{ status, statusCode, message }`
 * and return HTTP 200 even when the operation was refused, so `apiClient` sees
 * a success. The service layer converts those bodies into rejections that look
 * like Axios errors and therefore flow through `getApiErrorMessage`, keeping
 * the server's own copy.
 */
import { HTTP_STATUS } from '../../constants';
import type { ApiError } from '../../types';

export const createAdminRequestError = (
  message: string | null | undefined,
  status?: number,
): ApiError => ({
  response: {
    status: status ?? HTTP_STATUS.BAD_REQUEST,
    data: message ? { message } : {},
  },
});
